import { FIELD_VALUE_TYPE } from '@constants'

export const getIdForListRequest = (
  valueId: string | undefined,
  typeId: FIELD_VALUE_TYPE | undefined
) => {
  if (typeId === FIELD_VALUE_TYPE.OBJ_INTERNAL_ID_LINK) {
    return {
      formObjectInternalId: valueId,
    }
  }

  return {
    formObjectId: valueId,
  }
}
